var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"dialog",attrs:{"visible":_vm.visible,"width":"400px","top":"10vh"},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.dialogClose}},[_c('file-uploader',{attrs:{"options":_vm.uploadOptions,"acceptType":_vm.acceptType,"single":_vm.single,"autoStart":true},on:{"complete":_vm.allFilesUploaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }